import store from '@/store';

export default function (_this) {
  return {
    /**
     * Add new chart widget
     * @param {Object} data - data required
     * @param gsOptions
     */
    async add (data, gsOptions) {
      const widget = {
        template: '',
        gsOptions,
        tab: data.tab,
        subtab: data.subtab,
        layout:'b-card'
      }

      const widgetKey = await new Promise((resolve) => {
        const key = _this.getRef('widgets').push(widget, () => {
          resolve(key)
        }).key
      });

      store.commit('addedWidgetKey', widgetKey);

      const chartOptions = {
        type: data.defaultChartType
      }

      await new Promise((resolve) => {
        _this.getRef(`widgetsData/charts/${data.chartId}`)
          .set(chartOptions, (err) => {
            if (err) console.error(err)
            resolve()
          })
      })

      await new Promise((resolve) => {
        _this.getRef(`widgets/${widgetKey}/dependency`)
          .set(`charts/${data.chartId}`, () => (resolve()))
      })

      _this.getRef(`widgets/${widgetKey}/template`)
        .set(`<Chart chartId="${data.chartId}" :rData="${data.dataExp}" :widgetKey="widgetKey" />`)
    },
    /**
     * Read chart options
     * @param chartId - chart id
     */
    readOptions (chartId, template) {
      return new Promise((resolve) => {
        if (template) {
          _this.root.ref('dashboards')
            .child(template)
            .child(`widgetsData/charts`)
            .child(chartId)
            .once('value', (snapshot) => {
              resolve(snapshot.val())
            })
        } else {
          _this.getRef(`widgetsData/charts/${chartId}`).once('value', (snapshot) => {
            resolve(snapshot.val())
          })
        }
      })
    },
    /**
     * Set default chart type
     * @param {string} chartId - chart id
     * @param {string} type - chart type
     */
    setActiveChartType (chartId, type) {
      _this.getRef(`widgetsData/charts/${chartId}/type`).set(type)
    },
    /**
     * Set data settings for chart
     * @param {string} newOptions - new chart options containing: lable1, label2, data
     */
    async setNewLablesAndData (chartId, newOptions) {
      const options = await new Promise((resolve) => {
        _this.getRef(`widgetsData/charts/${chartId}`).once('value', (snapshot) => {
          resolve(snapshot.val())
        })
      })

      const { label, data, label2 } = newOptions

      options.label = label || null
      options.data = data || null
      options.label2 = label2 || null

      _this.getRef(`widgetsData/charts/${chartId}`).set(options)
    }
  }
}
